import React from 'react';
import { LinearProgress } from '@rmwc/linear-progress';
import '@rmwc/linear-progress/styles';

const Loading = () => <LinearProgress />;

export default Loading;
